import { matchPath, useLocation } from 'react-router-dom';

type T = string | undefined;

export const useCurrentProjectId = <ReturnType extends T = string | undefined>(): ReturnType => {
  return useMatchPathParams<{ projectId: string }>('/p/:projectId/*')?.projectId as ReturnType;
};

export const useCurrentEnvironmentId = () =>
  useMatchPathParams<{ environmentId: string }>('/p/:projectId/environments/:environmentId/*')?.environmentId;

export const useCurrentTemplateId = () =>
  useMatchPathParams<{ templateId: string }>('/templates/:templateId/*')?.templateId;

const useMatchPathParams = <T extends { [K in keyof T]?: string | undefined }>(pathPattern: string): T | undefined => {
  const location = useLocation();
  const match = matchPath(pathPattern, location.pathname);

  return match?.params as T | undefined;
};
